import affiliateEn from './en/en.json'
import affiliateAr from './ar/ar.json'
import affiliateEs from './es/es.json'
import affiliateDe from './de/de.json'
import affiliateIt from './it/it.json'
import affiliatePt from './pt/pt.json'
import affiliateBn from './bn/bn.json'
import affiliateSr from './sr/sr.json'
import affiliateCs from './cs/cs.json'
import affiliatePl from './pl/pl.json'
import affiliateHu from './hu/hu.json'
import affiliateSk from './sk/sk.json'
import affiliateRo from './ro/ro.json'
import affiliateBg from './bg/bg.json'
import affiliateMk from './mk/mk.json'
import affiliateSq from './sq/sq.json'

const AffiliateMessages = {
  en: { affiliate: { ...affiliateEn } },
  ar: { affiliate: { ...affiliateAr } },
  es: { affiliate: { ...affiliateEs } },
  de: { affiliate: { ...affiliateDe } },
  it: { affiliate: { ...affiliateIt } },
  pt: { affiliate: { ...affiliatePt } },
  bn: { affiliate: { ...affiliateBn } },
  sr: { affiliate: { ...affiliateSr } },
  cs: { affiliate: { ...affiliateCs } },
  pl: { affiliate: { ...affiliatePl } },
  hu: { affiliate: { ...affiliateHu } },
  sk: { affiliate: { ...affiliateSk } },
  ro: { affiliate: { ...affiliateRo } },
  bg: { affiliate: { ...affiliateBg } },
  mk: { affiliate: { ...affiliateMk } },
  sq: { affiliate: { ...affiliateSq } },
}

export default AffiliateMessages
